module.exports = __webpack_public_path__ + "static/media/FontAwesome5_Solid.1ab236ed.ttf";